<p *ngFor="let info of warningInfo" class="warning-info-text__item">
  <span class="warning-info-text__bold">{{info.count}}</span> <span>{{info.text}}</span>
</p>
